import { render } from "./Transaction.vue?vue&type=template&id=e9062956&scoped=true"
import script from "./Transaction.vue?vue&type=script&lang=js"
export * from "./Transaction.vue?vue&type=script&lang=js"

import "./Transaction.vue?vue&type=style&index=0&id=e9062956&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-e9062956"

export default script